import { useCallback, useMemo } from 'react';
import useLibTracker from 'personalization-lib/hooks/tracking/library/useLibTracker';
import { BUTTON_CLICK_ACTIONS, LIBRARY_USAGE_EVENTS } from 'personalization-lib/constants/tracking/libEvents';
const useCreateButtonClickTracker = ({
  actionSource,
  data
}) => {
  const track = useLibTracker(LIBRARY_USAGE_EVENTS.BUTTON_CLICK);
  const createButtonClickTracker = useCallback(action => () => track({
    action,
    actionSource,
    assetType: data === null || data === void 0 ? void 0 : data.assetType,
    targetingKind: data === null || data === void 0 ? void 0 : data.targetingKind,
    segmentType: data === null || data === void 0 ? void 0 : data.segmentType,
    assetId: Boolean(data === null || data === void 0 ? void 0 : data.assetId),
    isNew: !(data !== null && data !== void 0 && data.strategyId)
  }), [track, actionSource, data]);
  return useMemo(() => ({
    createPersonalization: createButtonClickTracker(BUTTON_CLICK_ACTIONS.createPersonalization),
    createPersonalizationWithAi: createButtonClickTracker(BUTTON_CLICK_ACTIONS.createPersonalizationWithAi)
  }), [createButtonClickTracker]);
};
export default useCreateButtonClickTracker;